export const PAYMENT_STEPS = {
	COURSE_INFO: 0,
	PAYMENT_METHOD: 1,
	PAYMENT: 2,
} as const;

export const PRODUCT_TYPES = {
	TARIFF: 'tariff',
	SUBSCRIPTION: 'subscription',
} as const;

export const PAYMENT_METHODS = {
	LOAN: 'LOAN',
	FULL: 'FULL',
	DOLYAMI: 'DOLYAMI',
} as const;

export const PAYMENT_DURATIONS = {
	3: '3-months',
	4: '4-months',
	6: '6-months',
} as const;

export const PAYMENT_METHODS_DATA = [
	{
		id: PAYMENT_METHODS.DOLYAMI,
		title: 'Долями',
		icon: 'chart-pie-slice',
	},
	{
		id: PAYMENT_METHODS.LOAN,
		title: 'Рассрочка от 3 до 6 месяцев',
		icon: 'percent',
	},
	{
		id: PAYMENT_METHODS.FULL,
		title: 'Полная оплата',
		icon: 'bag',
	},
];

const faqDefault = [
	{
		question: 'Где можно подробнее узнать про курс?',
		answer:
			'Все условия более подробно описаны <a class="text-accent font-semibold underline" href="/algorithms" target="_blank">тут</a>.',
	},
	{
		question: 'Что будет после оплаты?',
		answer:
			'Тебе сразу откроется доступ к курсу, а так же придет сообщение об успешной оплате на почту и чек.',
	},
	{
		question: 'Что делать, если что-то пошло не так?',
		answer:
			'В экстренной ситуации можешь написать основателю algocode.io в телеграмм: <a class="text-accent font-semibold underline" rel="noopener noreferrer" href="https://t.me/fatinmaks" target="_blank">@fatinmaks</a>.',
	},
];

const advantagesDefault = [
	'Доступ к материалам курса на 1 год',
	'Более 80 видео-разборов эталонных решений к задачам',
	'Программа составлена опытными интервьюерами из MAANG и российского BigTech.',
	'Более 80 алгоритмических задач',
	'Уникальные задачи с реальных собеседований',
	'Доступна оплата частями и в рассрочку',
	'Учись по четкой системе паттернов, чтобы не забывать решения задач',
	'Регулярное обновление программы',
];

export const algoBigTechPaymentData = {
	paymentMethodsData: PAYMENT_METHODS_DATA,
	advantages: advantagesDefault,
	faq: faqDefault,
};
